import { ActionIcon, Group, TextInput } from "@mantine/core";
import { IconLayoutList, IconList, IconSearch } from "@tabler/icons-react";
import { useIntl } from "react-intl";
import { memo, type FC } from "react";

interface DatasetListControlsProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  isCondensedView: boolean;
  toggleView: () => void;
}

export const DatasetListControls: FC<DatasetListControlsProps> = memo(({
  searchQuery,
  setSearchQuery,
  isCondensedView,
  toggleView,
}) => {
  const intl = useIntl();

  return (
    <Group justify="space-between" align="center" mb="md">
      <Group gap="xs">
        <ActionIcon
          variant="default"
          size="lg"
          aria-label={intl.formatMessage({
            defaultMessage: "Toggle view",
            id: "button.toggleView",
          })}
          onClick={toggleView}
        >
          {isCondensedView
            ? <IconLayoutList size={18} />
            : <IconList size={18} /> }
        </ActionIcon>

        <TextInput
          placeholder={intl.formatMessage({
            defaultMessage: "Search datasets...",
            id: "placeholder.searchDatasets",
          })}
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.currentTarget.value);
          }}
          leftSection={<IconSearch size={16} />}
          w="320px"
        />
      </Group>
    </Group>
  );
});
